import { render, staticRenderFns } from "./LocationCreate.vue?vue&type=template&id=704b0d0a"
import script from "./LocationCreate.vue?vue&type=script&lang=js"
export * from "./LocationCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports